"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

const IconWifi = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/_react.default.createElement("title", null, title) : null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.52 11.474a11.75 11.75 0 0115.04 0 .75.75 0 11-.96 1.152 10.25 10.25 0 00-13.12 0 .75.75 0 01-.96-1.152z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M.924 7.937c6.33-5.58 15.822-5.58 22.152 0a.75.75 0 01-.992 1.126 15.25 15.25 0 00-20.168 0 .75.75 0 11-.992-1.126zm7.172 7.062a6.75 6.75 0 017.819 0 .75.75 0 01-.87 1.222 5.25 5.25 0 00-6.08 0A.75.75 0 018.094 15zm3.914 3.751a.75.75 0 01.102 1.493L12 20.25a.75.75 0 01-.102-1.493l.112-.007z"
  }));
};

const ForwardRef = /*#__PURE__*/_react.default.forwardRef((props, ref) => /*#__PURE__*/_react.default.createElement(IconWifi, (0, _extends2.default)({
  svgRef: ref
}, props)));

var _default = ForwardRef;
exports.default = _default;